import React from "react";
import useUsernameInput from "../../../../hooks/useUsernameInput";

function PaymentGatewayCard({ name, config, data, errors, onToggle, onChange }) {
  useUsernameInput();

  return (
    <div className="row">
      <div className="col-xl-12 col-lg-12 col-md-6 d-flex">
        <div className="card flex-fill mb-3">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <div className="d-flex align-items-center">
                <span className="system-app-icon">
                  <img
                    src={`${process.env.PUBLIC_URL}${config.image}`}
                    alt={config.label}
                  />
                </span>
                <div className="security-title ms-2">
                  <a
                    href={config?.websiteUrl}
                    className="fs-16 fw-medium text-primary"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {config?.label}
                  </a>
                </div>
              </div>

              <div className="status-toggle modal-status d-flex align-items-center ms-2">
                <input
                  type="checkbox"
                  id={`${name}-toggle`}
                  className="check"
                  checked={data.enabled}
                  onChange={() => onToggle(name)}
                />
                <label
                  htmlFor={`${name}-toggle`}
                  className="checktoggle"
                ></label>
              </div>
            </div>

            <p className="fs-14 mb-3">
              Enable {config.label} for additional payment options.
            </p>

            {data.enabled && (
              <div className="row shipment">
                {config?.setupSteps && (
                  <div className="col-md-12 mb-2">
                    <div className="alert alert-light border">
                      <ol className="ps-3">
                        {config?.setupSteps?.map((step, index) => (
                          <li key={index}>{step}</li>
                        ))}
                      </ol>
                    </div>
                  </div>
                )}

                {config.fields &&
                  config.fields.map((field) => {
                    const value = data.additionalSettings?.[field.name] ?? "";

                    const fieldErrorKey = `${name}_${field.name}`;
                    const errorMessage = errors[fieldErrorKey];

                    if (field.type === "select") {
                      return (
                        <div className="col-md-6 mb-3" key={field.name}>
                          <label className="form-label">{field.label}</label>
                          <select
                            className={`form-select ${errorMessage ? "is-invalid" : ""}`}
                            value={value}
                            onChange={(e) =>
                              onChange(name, field.name, e.target.value)
                            }
                          >
                            {field.options &&
                              field.options.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                          </select>
                          {errorMessage ? (
                            <div className="invalid-feedback">
                              {errorMessage}
                            </div>
                          ) : (
                            field.helperText && (
                              <small className="form-text text-muted">
                                {field.helperText}
                              </small>
                            )
                          )}
                        </div>
                      );
                    }

                    if (field.type === "textarea") {
                      return (
                        <div className="col-12 mb-3" key={field.name}>
                          <label className="form-label">{field.label}</label>
                          <textarea
                            className={`form-control ${errorMessage ? "is-invalid" : ""}`}
                            rows={3}
                            value={value}
                            placeholder={field.placeholder}
                            onChange={(e) =>
                              onChange(name, field.name, e.target.value)
                            }
                          />
                          {errorMessage ? (
                            <div className="invalid-feedback">
                              {errorMessage}
                            </div>
                          ) : (
                            field.helperText && (
                              <small className="form-text text-muted">
                                {field.helperText}
                              </small>
                            )
                          )}
                        </div>
                      );
                    }

                    return (
                      <div className="col-md-6 mb-3" key={field.name}>
                        <label className="form-label">{field.label}</label>
                        <input
                          type={field.type || "text"}
                          className={`form-control ${errorMessage ? "is-invalid" : ""}`}
                          value={value}
                          placeholder={field.placeholder}
                          onChange={(e) =>
                            onChange(name, field.name, e.target.value)
                          }
                        />
                        {errorMessage ? (
                          <div className="invalid-feedback">{errorMessage}</div>
                        ) : (
                          field.helperText && (
                            <small className="form-text text-muted">
                              {field.helperText}
                            </small>
                          )
                        )}
                      </div>
                    );
                  })}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentGatewayCard;
